export default function renderPrice(price) {
    return price.replace(/\./, ",");;
}